import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';

const PromotionsList = React.lazy(() => import('./Promotions'));

function Promotions(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست پروموشن‌ها</PageTitle>
        <Button as={Link} type="anchor" to="/promotions/new">
          ساخت پروموشن
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <PromotionsList {...props} />
      </Suspense>
    </Page>
  );
}

export default Promotions;
